<template>
  <component :is="layout_component" ref="layout"></component>
</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  import {
    get,
    post
  } from '@/services/index.js'
  import moment from 'moment'
  import BookingTableMobileLayout from './layouts/BookingTableMobileLayout';
  import BookingTableWideLayout from './layouts/BookingTableWideLayout';
import { applyResolvedTitle } from '../../../../utils/titleService';
import { trackPageViewAfterDataLoaded } from '../../../../utils/analytics';

  export default {
    components:{
      BookingTableMobileLayout,
      BookingTableWideLayout
    },
    provide() {
      return {
        bookingContext: this
      }
    },
    data() {
      return {
        is_load: true,
        error: '',
        general_data: {},
        form:{
          date:{
            startDate: null,
            endDate: null
          },
          time:{
            list: [],
            selected: ''
          },
          guest:{
            adult: 1,
            child: 0
          },
          notes: ''
        },
        date_setting:{
          min_date: moment().toDate(),
          show_calendar: false
        },
        error_push: '',
        validation_form: {
          date: false,
          time: false
        }
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getCurrentUser',
        'getOutletTrxCustomerDetail',
        'getMetaTitleTemplate'
      ]),
      pos_code() {
        return this.$route.params.pos_code
      },
      selected_date(){
        let date = ''
        if(this.form.date.startDate != null) date = this.$formatDate(this.form.date.startDate)
        return date
      },
      page_design_type() {
        const page_design = this.general_data.page_design ? this.general_data.page_design : 'MOBILE_VIEW';
        return (page_design === 'WIDE_VIEW' && !this.$is_mobile_view) ? 'WIDE_VIEW' : 'MOBILE_VIEW'
      },
      layout_component() {
        return this.page_design_type === 'WIDE_VIEW' ? 'BookingTableWideLayout' : 'BookingTableMobileLayout'
      }
    },
    watch:{
      selected_date(){
        this.date_setting.show_calendar = false
        this.generateTimeSerives()
        setTimeout(() => {
          if(this.form.time.selected == '' && this.form.time.list.length > 0){
            if (this.$refs.layout && this.$refs.layout.$refs.dd_time) {
              this.$refs.layout.$refs.dd_time.show()
            }
            if (this.$refs.layout && this.$refs.layout.$refs.dd_time_wide) {
              this.$refs.layout.$refs.dd_time_wide.show()
            }
          }
        }, 300);
      }
    },
    mounted(){
      this.loadFirstData() 
    },
    destroyed(){
      this.resetTrxOutletCustomerDetail()
    },
    methods:{
      ...mapMutations(['setTrxOutletCustomerDetail','resetAllDataConcierge','resetTrxOutletCustomerDetail']),
      loadFirstData() {
        this.is_load = true
        let func_exe = [this.loadGeneralData()]
        Promise.all(func_exe)
        .catch(err=>this.error = err)
        .finally(() => {
          if(!this.general_data.use_booking_table) this.goToPage('PosHome')
          this.is_load = false
          this.setupPageForm()
          setTimeout(() => {
            this.$smoothScroll('top-section')
          }, 100);
        })
      },
      loadGeneralData() {
        return new Promise((success, fail) => {
          this.general_data = {}
          get("CORE_HOTEL", `merchant-pos/${this.pos_code}/general`, {
            merchant_id: this.getMerchant.id
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.general_data = res.data
              this.$validatePage('CONCIERGE',this.general_data).then(()=>{
                applyResolvedTitle({router: this.$router, title: `Reserve a table - ${res.data.tagline}`, trackFn: () => {
                  trackPageViewAfterDataLoaded()
                }})
                
                success()
              }).catch(()=>fail())
            } else {
              fail(res.message)
            }
          })
        })
      },
      setupPageForm(){
        if(this.form.date.startDate == null) this.date_setting.show_calendar = true
        this.generateTimeSerives()
        this.fillCustomerData()
      },
      fillCustomerData(){
        let data = this.getCurrentUser
        let vuex_data = this.$deepCopy(this.getOutletTrxCustomerDetail)
        let params = []
        if (!this.$isNotEmpty(vuex_data.first_name)) {
          params.push({
            key: 'first_name',
            value: data.first_name
          })
        }
        if (!this.$isNotEmpty(vuex_data.last_name)) {
          params.push({
            key: 'last_name',
            value: data.last_name
          })
        }
        if (!this.$isNotEmpty(vuex_data.email)) {
          params.push({
            key: 'email',
            value: data.email
          })
        }
        if (!this.$isNotEmpty(vuex_data.phone_number)) {
          params.push({
            key: 'phone_number',
            value: data.phone
          })
        }
        if (params.length > 0) {
          this.setTrxOutletCustomerDetail(params)
        }
      },
      generateTimeSerives(){
        if(this.form.date.startDate != null){
          let time_list = []
          if(this.general_data.use_daily_operational_hour){
            let selected_date = moment(this.form.date.startDate).format("dddd")
            let selected_day = selected_date.toLowerCase()
            let sale_day_key = `sale_${selected_day}`
            let time_key = {
              start: `time_start_${selected_day}`,
              end: `time_end_${selected_day}`
            }
            if(this.general_data[sale_day_key]){
              let time_start = moment(this.general_data[time_key.start],'HH:mm:ss').toDate()
              let time_end = moment(this.general_data[time_key.end],'HH:mm:ss').subtract(59,'m').toDate()
              let today = moment().toDate()
              
              let is_date_today = moment(this.form.date.startDate).isSame(today,'day')
              if(is_date_today){
                let is_today_hour_after_time_start = moment(today).isAfter(time_start)
                if(is_today_hour_after_time_start){
                  let today_hour = moment(today).format("H")
                  let today_minute = moment(today).format('mm')
                  let is_today_pass_30m = Number(today_minute) < 30
                  if(is_today_pass_30m){
                    time_start = moment().set('hour',today_hour)
                    time_start = moment().set('minute', 30)
                  }else{
                    time_start = moment().set('hour',Number(today_hour)+1)
                    time_start = moment().set('minute', 0)
                  }
                }
              }

              if(moment(time_start).isSameOrBefore(time_end)){
                do {
                  time_list.push(moment(time_start).format("HH:mm"))
                  time_start = moment(time_start).add(30,'m').toDate()
                } while (moment(time_start).isSameOrBefore(time_end))
              }
            }else{
              console.log("DAY CLOSE")
            }
            
          }else{
            let time_start = moment(this.general_data.time_start,'HH:mm:ss').toDate()
            let time_end = moment(this.general_data.time_end,'HH:mm:ss').subtract(59,'m').toDate()

            let today = moment().toDate()
            let is_date_today = moment(this.form.date.startDate).isSame(today,'day')
            if(is_date_today){
              let is_today_hour_after_time_start = moment(today).isAfter(time_start)
              if(is_today_hour_after_time_start){
                let today_hour = moment(today).format("H")
                let today_minute = moment(today).format('mm')
                let is_today_pass_30m = Number(today_minute) < 30
                if(is_today_pass_30m){
                  time_start = moment().set('hour',today_hour)
                  time_start = moment().set('minute', 30)
                }else{
                  time_start = moment().set('hour',Number(today_hour)+1)
                  time_start = moment().set('minute', 0)
                }
              }
            }
            
            if(moment(time_start).isSameOrBefore(time_end)){
              do {
                time_list.push(moment(time_start).format("HH:mm"))
                time_start = moment(time_start).add(30,'m').toDate()
              } while (moment(time_start).isSameOrBefore(time_end))
            }
  
          }
          this.form.time.list = time_list
        }else{
          this.form.time = {
            list: [],
            selected: ''
          }
        }
      },
      goToPage(page) {
        let route = {
          name: page,
          params: {
            merchant_code: this.getMerchant.code,
            pos_code: this.pos_code
          }
        }
        this.$router.push(route)
      },
      formatDateNumber(value) {
        return moment(value).format("D")
      },
      dateFormat (classes, date) {
        if (!classes.disabled && this.general_data.use_daily_operational_hour) {
          let selected_date = moment(date).format("dddd")
          let selected_day = selected_date.toLowerCase()
          let sale_day_key = `sale_${selected_day}`
          
          classes.disabled = !this.general_data[sale_day_key]
        }
        return classes
      },
      toggleDetailCalendar(){
        this.date_setting.show_calendar = !this.date_setting.show_calendar
      },
      selectTimeService(time){
        this.form.time.selected = time
      },
      changeQtyGuest(field,action){
        let is_adult_going_to_0 = field == 'adult' && action == 'minus' && this.form.guest.adult == 1
        if(!is_adult_going_to_0){
          if(action == 'plus' || (action == 'minus' && this.form.guest[field] > 0)){
            let guest_qty = this.form.guest[field]
            this.form.guest[field] = action == 'minus' ? guest_qty-1 : guest_qty+1
          }
        }
      },
      validateAllForm(){
        return new Promise((success,fail)=>{
          this.validation_form = {
            date: false,
            time: false
          }
          if(this.form.date.startDate == null){
            this.$smoothScroll('top-section')
            this.validation_form.date = true
            success()
          }else if(this.form.time.selected == ''){
            this.$smoothScroll('mid-section')
            this.validation_form.time = true
            success()
          }else{
            this.$refs.layout.validateGuestForm().then(()=>{
              success()
            }).catch(()=>{
              this.$smoothScroll(this.page_design_type === 'WIDE_VIEW' ? 'for-guest-form-wide' : 'for-guest-form')
              fail()
            })
          }
        })
      },
      submitForm(){
        return new Promise((success,fail)=>{
          this.validateAllForm().then(()=>{
            let book_date = () =>{
              let date = moment(this.form.date.startDate).format("YYYY-MM-DD")
              let time = moment(this.form.time.selected,'HH:mm').format("HH:mm:ss")
              let date_time = `${date} ${time}`
              return date_time
            }

            let params = {
              book_date: book_date(),
              customer_details: this.getOutletTrxCustomerDetail,
              guest_detail: this.form.guest,
              merchant: this.getMerchant.id,
              merchant_pos: this.general_data.id,
              note: this.form.notes
            }
            post("CORE_HOTEL","merchant-pos/table-reservation/tx-inquiry",params).then(response=>{
              let res = response.data
              if(res.success){
                this.resetAllDataConcierge()
                let route = {
                  name: 'PosBookingTableResult',
                  params: {
                    merchant_code: this.getMerchant.code,
                    pos_code: this.pos_code,
                    tx_order_id: res.data.id
                  }
                }
                this.$router.push(route)
              }else{
                this.error_push = res.message
              }
              success()
            })
          }).catch(()=>fail())
        })
      }
    }
  }
</script>
<style>
  .height-animated {
    height: 0px;
    max-height: 0px;
    transition: max-height 0.5s;
    overflow: hidden;
  }

  .height-animated.active {
    height: auto;
    max-height: 1000px;
    transition: max-height 0.5s;
  }
  .pos-order-qty {
    cursor: pointer;
    width: 35px;
    height: 35px;
    display: grid;
    place-items: center;
    text-align: center;
    border-radius: 6px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/BookingTable.vue